import { useContext, useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import {
  Box
  , Container
  , Typography
} from '@mui/material/'
import Copyright from '../components/Copyright'
import UserForm from '../components/forms/UserForm'
import { ThemeContext } from '../App'
import { getBrandingUrls } from '../config/market'

const BRAND = getBrandingUrls()

export default function Signup ({ isMobile }) {
  const { mode } = useContext(ThemeContext)
  const navigate = useNavigate()
  const location = useLocation()
  const token = location.state?.token || null
  
  const logoUrl = mode === 'dark' ? BRAND.authLogoDark : BRAND.authLogoLight

  useEffect(() => {
    if (token) return navigate('/home', { state: { token } })
  }, [token, navigate])

  return (
    <Container
      component="main"
      maxWidth={isMobile ? 'xs' : 'sm'}
      sx={{
        py: { xs: 1, sm: 1.5 },
        px: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        sx={{ width: '100%', gap: 0.5 }}
      >
        <Box sx={{ width: '100%', maxWidth: { xs: 260, sm: 300 }, flexShrink: 0 }}>
          <img src={logoUrl} alt='ADaMS logo' width='100%' style={{ display: 'block' }} />
        </Box>
        <UserForm isMobile={isMobile} token={token} compactSignup />
        <Typography
          variant="body2"
          sx={{
            mt: 0.75,
            textAlign: 'center',
            fontSize: { xs: '0.9375rem', sm: '1rem' },
            lineHeight: 1.5,
          }}
        >
          <Trans>Already signed up? Please&nbsp;
            <Link to="/">login</Link>
          </Trans>
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 3, sm: 5 },
          flexWrap: 'wrap',
          mt: 1.5,
          flexShrink: 0,
        }}
      >
        <img
          src={BRAND.loginFlag}
          alt=""
          style={{ height: 'auto', width: 'auto', maxWidth: 120 }}
        />
        <img
          src={BRAND.loginSeal}
          alt=""
          style={{ height: 'auto', width: 'auto', maxWidth: 100 }}
        />
      </Box>
      <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
        <Copyright />
      </Box>
    </Container>
  )
}
